module.exports = "https://web-assets.ifttt.com/packs/media/shared/pinned-dea346ab.png";